import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchContentReviews } from 'src/services/napi/contentReview/fetchContentReviewData/intex';

const fetchContentReviewsData = async (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
}) => {
  const { orderBy, orderDirection, page, pageSize } = params;
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;
  const data = await fetchContentReviews({
    orderBy: orderBy || 'created',
    orderDirection: orderDirection || '-1',
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id
  });
  return data;
};

export const useGetContentReviews = (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
}) => {
  const { notify } = useNotification();
  const { orderBy, orderDirection, page, pageSize } = params;

  return useQuery(
    [QueryKey.CONTENT_REVIEWS, page, pageSize, orderBy, orderDirection],
    () =>
      fetchContentReviewsData({
        orderBy,
        orderDirection,
        page,
        pageSize
      }),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
